/* eslint-disable react/prop-types */
import React from "react";
import DatePicker from "react-flatpickr";
import { Vietnamese } from "flatpickr/dist/l10n/vn";
import { Box, Typography } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftInput from "components/SoftInput";
import SwitchBox from "components/SwitchBox";
import SoftTypography from "components/SoftTypography";

const selectStyle = {
  fontSize: "0.875rem",
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
};

const ModalContent = ({ list, pickAll, setPickAll, handleChangeSwitch }) => {
  const [taxPeriod, setTaxPeriod] = React.useState("month"); // | quarterly
  const [taxType, setTaxType] = React.useState("firstTime"); // | additional

  return (
    <>
      <Box
        sx={{
          p: 1,
          border: "1px solid black",
          borderRadius: 1,
        }}
      >
        <Typography id="modal-modal-title" variant="h6" component="h2">
          Chọn kỳ tính thuế
        </Typography>

        <SoftBox display="flex" flexDirection="column" my={1}>
          <SoftTypography component="label" variant="caption" fontWeight="bold" mb={0.5}>
            CQT cấp Cục
          </SoftTypography>
          <select style={selectStyle}>
            <option value="1">HCM - Cục Thuế Thành phố Hồ Chí Minh</option>
            <option value="2">Value 2</option>
          </select>
        </SoftBox>
        <SoftBox display="flex" flexDirection="column" mt={1} mb={2}>
          <SoftTypography component="label" variant="caption" fontWeight="bold" mb={0.5}>
            CQT nơi nộp
          </SoftTypography>
          <select style={selectStyle}>
            <option value="1">Cục Thuế Thành phố Hồ Chí Minh</option>
            <option value="2">Value 2</option>
          </select>
        </SoftBox>
        <Box
          sx={{
            display: "flex",
            gap: 1,
          }}
        >
          <Box>
            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Ngày
              </SoftTypography>
            </SoftBox>
            <SoftInput name={taxPeriod} type="number" defaultValue={10} />
          </Box>
          <Box>
            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Tháng
              </SoftTypography>
            </SoftBox>
            <SoftInput name={taxPeriod} type="number" defaultValue={10} />
          </Box>
          <Box>
            <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Năm
              </SoftTypography>
            </SoftBox>
            <SoftInput name="year" type="number" />
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default ModalContent;
